const ATTRIBUTION_PARAMETERS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "gbraid",
  "wbraid",
] as const;

/**
 * Preserve paid attribution during a fast landing -> Studio click when the
 * session endpoint has not yet returned an attribution token. The token wins
 * when available. Values are copied only after the user's analytics consent.
 *
 * Only the owned Studio destination is eligible. Raw user-provided query
 * parameters, emails and potentially sensitive URLs are never forwarded.
 */
export function studioLinkWithAttribution(
  destination: string,
  currentPage: string,
  analyticsConsent: "granted" | "denied" | "unknown",
  attributionToken?: string | null,
): string {
  const target = new URL(destination, currentPage);
  if (
    target.protocol !== "https:" ||
    target.hostname !== "studio.sendbot.co" ||
    analyticsConsent !== "granted"
  ) {
    return target.toString();
  }

  const token = attributionToken?.trim();
  if (token && token.length <= 180 && /^[a-zA-Z0-9_-]+$/.test(token)) {
    target.searchParams.set("attributionToken", token);
    return target.toString();
  }

  const source = new URL(currentPage);
  for (const parameter of ATTRIBUTION_PARAMETERS) {
    const value = source.searchParams.get(parameter)?.trim();
    if (
      !value ||
      value.length > 180 ||
      Array.from(value).some(
        (character) =>
          character.charCodeAt(0) <= 31 || character.charCodeAt(0) === 127,
      )
    )
      continue;
    if (!target.searchParams.has(parameter))
      target.searchParams.set(parameter, value);
  }
  return target.toString();
}
